import React, { useState } from 'react';

const HelpModal = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('information');

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-[800px] h-[600px] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-[#0077BE] flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800">Help</h2>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Tabs */}
                <div className="flex border-b border-gray-200">
                    <button
                        className={`px-6 py-3 ${activeTab === 'information' ? 'bg-[#E8F4FA] border-t-2 border-[#0077BE] font-medium' : 'bg-gray-50'}`}
                        onClick={() => setActiveTab('information')}
                    >
                        Information
                    </button>
                    <button
                        className={`px-6 py-3 ${activeTab === 'test_help' ? 'bg-[#E8F4FA] border-t-2 border-[#0077BE] font-medium' : 'bg-gray-50'}`}
                        onClick={() => setActiveTab('test_help')}
                    >
                        Test help
                    </button>
                    <button
                        className={`px-6 py-3 ${activeTab === 'task_help' ? 'bg-[#E8F4FA] border-t-2 border-[#0077BE] font-medium' : 'bg-gray-50'}`}
                        onClick={() => setActiveTab('task_help')}
                    >
                        Task help
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 p-6 overflow-y-auto">
                    {activeTab === 'information' && (
                        <div className="space-y-4">
                            <h3 className="text-lg font-medium text-gray-900">About this test</h3>
                            <p className="text-gray-600">This is an Academic Writing test. There are 2 writing tasks:</p>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Task 1 - write a report based on visual information (graph/table/chart/diagram). Write at least 150 words in 20 minutes.</li>
                                <li>Task 2 - write an essay in response to an argument or problem. Write at least 250 words in 40 minutes.</li>
                            </ul>
                        </div>
                    )}

                    {activeTab === 'test_help' && (
                        <div className="space-y-4">
                            <h3 className="text-lg font-medium text-gray-900">Test Instructions</h3>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>You have 60 minutes to complete both tasks</li>
                                <li>Spend 20 minutes on Task 1 and 40 minutes on Task 2</li>
                                <li>Task 2 is worth twice as many marks as Task 1</li>
                                <li>You can move between tasks using the navigation buttons</li>
                                <li>Your answers will be marked on:</li>
                                <ul className="list-circle pl-5 mt-2 space-y-1">
                                    <li>Task achievement</li>
                                    <li>Coherence and cohesion</li>
                                    <li>Vocabulary</li>
                                    <li>Grammar</li>
                                </ul>
                            </ul>
                        </div>
                    )}

                    {activeTab === 'task_help' && (
                        <div className="space-y-4">
                            <h3 className="text-lg font-medium text-gray-900">Task 1 Help</h3>
                            <ul className="list-disc pl-5 space-y-2 text-gray-600">
                                <li>Study the graph/chart carefully</li>
                                <li>Identify the main trends and key features</li>
                                <li>Write an introduction describing what the visual shows</li>
                                <li>Organize your description logically</li>
                                <li>Include relevant data and comparisons</li>
                                <li>Do not give opinions or reasons not shown in the visual</li>
                                <li>Use appropriate language for describing trends</li>
                                <li>Check your word count (minimum 150 words)</li>
                            </ul>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-[#0077BE] text-white rounded hover:bg-[#005A8C] transition-colors"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HelpModal; 